import Skeleton from 'react-loading-skeleton'

const CompareSkeleton = () => (
  <Skeleton count={3} height={320} style={{ marginBottom: 20 }} />
)

export default CompareSkeleton
